<template>
  <div id="app">

    
    <!-- 显式声明router-view，确保子组件能正确渲染 -->
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      showDebug: true // 开发环境显示调试信息
    }
  },
  beforeCreate() {
    console.log('App组件beforeCreate')
  },
  created() {
    console.log('App组件created，当前路由路径:', this.$route.path)
  },
  beforeMount() {
    console.log('App组件beforeMount')
  },
  mounted() {
    console.log('App组件mounted，当前路由路径:', this.$route.path)
    
    // 检查router-view元素
    const routerView = this.$el.querySelector('router-view')
    console.log('App组件中的router-view元素:', routerView)
    
    // 输出子组件渲染情况
    console.log('App的子组件:', this.$children)
    
    // 强制更新组件，尝试解决子组件不渲染的问题
    this.$nextTick(() => {
      this.$forceUpdate()
      console.log('App组件已强制更新')
    })
    
    // 延迟检查DOM渲染情况
    setTimeout(() => {
      console.log('App延时检查 - router-view内容:', this.$el.innerHTML)
    }, 500)
  },
  methods: {
    // 重载应用方法
    reloadApp() {
      window.location.reload()
    }
  },
  watch: {
    // 监听路由变化
    '$route': {
      handler(to, from) {
        console.log('App监听到路由变化:', from && from.path, '->', to.path)
      },
      immediate: true
    }
  }
}
</script>

<style>
@import './assets/styles/index.css';

.route-debug {
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0,0,0,0.7);
  color: white;
  padding: 5px 10px;
  font-size: 12px;
  z-index: 10000;
}

.route-debug button {
  margin-left: 10px;
  background-color: #409EFF;
  border: none;
  color: white;
  padding: 2px 6px;
  border-radius: 3px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/App.vue